import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const KEY = 'eletrovex_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem(KEY);
    if (!consent) {
      // Small delay so it doesn't pop up immediately on first paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setVisible(false);
  };

  // Do not show on admin routes — admin operators don't need consent UI and it blocks clicks
  if (!visible || location.pathname.startsWith('/admin')) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50 pointer-events-none">
    <div
      className="bg-white border border-gray-200 rounded-2xl shadow-2xl p-5 md:p-6 max-w-3xl mx-auto pointer-events-auto"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Política de cookies"
    >
      <div className="flex items-start gap-4">
        <div className="bg-yellow-100 rounded-full p-2 flex-shrink-0">
          <Cookie className="text-yellow-600" size={24} />
        </div>
        <div className="flex-1">
          <p className="font-bold text-gray-900 mb-1">Cookies & Privacidade</p>
          <p className="text-sm text-gray-600 mb-3">
            Usamos cookies para melhorar sua experiência, lembrar seu carrinho e analisar
            o uso do site. Ao continuar, você concorda com nossa{' '}
            <Link to="/privacidade" className="text-blue-700 underline">
              Política de Privacidade
            </Link>
            .
          </p>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={accept}
              className="bg-blue-700 hover:bg-blue-800 text-white font-bold px-5 py-2 rounded-full text-sm"
              data-testid="cookie-accept"
            >
              Aceitar
            </button>
            <Link
              to="/privacidade"
              className="text-gray-600 hover:text-gray-900 px-4 py-2 text-sm font-semibold"
              data-testid="cookie-learn-more"
            >
              Saiba mais
            </Link>
          </div>
        </div>
        <button
          onClick={accept}
          className="text-gray-400 hover:text-gray-600 flex-shrink-0"
          aria-label="Fechar"
        >
          <X size={20} />
        </button>
      </div>
    </div>
    </div>
  );
};

export default CookieBanner;
